module.exports = __webpack_public_path__ + "static/media/portfolio3.14cdfeb4.jpg";